// /client/customer/src/utils/reservation/by-service/postCreateReservationByService.ts
import apiConfig from '../../../apiConfig';
import { getCustomerAuthHeaders } from '../../auth/customerAuthToken';

export type CreateReservationServiceLine = {
  service_id: number;
};

export type PostCreateReservationByServicePayload = {
  store_id: number;
  customer_id?: number | null;
  customer_name?: string | null;

  date: string;        // 'YYYY-MM-DD'
  staff_id: number | null;
  is_free?: boolean;
  start_time: string;  // 'HH:mm'

  services: CreateReservationServiceLine[]; // order 유지
  slot?: number;
};

export type PostCreateReservationByServiceResponse = {
  message: string;
  reservation_id: number;
};

export const postCreateReservationByService = async (
  payload: PostCreateReservationByServicePayload,
): Promise<PostCreateReservationByServiceResponse> => {
  const { store_id, date, staff_id, is_free, start_time, services } = payload;

  if (!Number.isFinite(store_id) || store_id <= 0) throw new Error('Invalid store_id');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new Error("date must be 'YYYY-MM-DD'");
  if (!is_free && (staff_id == null || !Number.isFinite(staff_id) || staff_id <= 0)) {
    throw new Error('Invalid staff_id');
  }
  if (!/^\d{2}:\d{2}$/.test(start_time)) throw new Error("start_time must be 'HH:mm'");
  if (!Array.isArray(services) || services.length === 0) throw new Error('services is required');

  const res = await fetch(
    `${apiConfig.baseURL}/api/customer-app/reservation/by-service/create`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...getCustomerAuthHeaders(),
      },
      body: JSON.stringify(payload),
    },
  );

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to create reservation');
  }

  return (await res.json()) as PostCreateReservationByServiceResponse;
};
